import api from '@/api'

const namespaced = true

const state = {
  dailyTrip: []
}

const getters = {
  dailyTrip: state => state.dailyTrip
}

const mutations = {
  SET_DAILY_TRIP: (state, payload) => {
    state.dailyTrip = payload
  }
}

const actions = {
  async fetchDailyTrip({ commit, rootGetters }, filterPayload) {
    try {
      const filterConfig = rootGetters['Table/defaultConfig']
      const filter = {
        ...filterPayload,
        search: filterConfig.search,
        page: filterConfig.currentPage || 1,
        limit: filterConfig.pageSize || 5
      }

      const { data } = await api.getDailyTripActivities(filter)
      if (data.error) {
        commit('SET_DAILY_TRIP', [])
        commit('Table/SET_TOTAL_DATA', 0, { root: true })
        commit('Table/SET_TOTAL_PAGE', 1, { root: true })
        return
      }

      commit('SET_DAILY_TRIP', data.data)
      commit('Table/SET_TOTAL_DATA', data.total, { root: true })
      commit('Table/SET_TOTAL_PAGE', data.pages, { root: true })
    } catch (err) {
      throw err
    }
  },
  async postEmailDailyTripActivities({ commit, __ }, _) {
    try {
      const { data } = await api.postEmailDailyTripActivities()
      if (data.error) {
        return
      }
      return data
    } catch (error) {
      throw error.data;
    }
  }
}

export default { namespaced, state, getters, mutations, actions }
